<template>
  <div v-for="(link) in filteredLinks" :key="`links-group--${link.uuid}`" class="links-group">
    <IconLink
      v-if="link.bundle === 'download'"
      :label="link.file.label"
      :url="useFileUrl(link.file.url.path)"
      :size="link.file?.fieldMediaFile.entity.filesize"
      :extension="link.file?.fieldMediaFile.entity.filemime"
      icon="CircleDownloadFilled"
    />
    <IconLink v-if="link.bundle === 'link'" :label="link.link.title" :url="link.link.uri.path" icon="CircleWebsiteFilled" />
  </div>
</template>

<script setup lang="ts">
import IconLink from './IconLink.vue'

const props = defineProps<{
  links: any
}>()

const filteredLinks = computed(() => {
  return props.links.filter((link: any) => {
    return link !== undefined
  })
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.links-group {
  display: flex;
  flex-direction: column;
  gap: var(--space--xs);
}
</style>
